import CargoPdf from "../../../components/Calculator/CargoPdf";
import { downloadPdf, makePdfBlob, sharePdf } from "../../../util/pdfFile";
import * as calculatorActions from "../Calculator/actions";
import { buildCargoPdfDetails } from "./AddNewOrder";
import * as actions from "./actions";

// Builds the same PDF as the New Cargo modal, for a row of the orders table. mode: "download" | "share"
export const exportCargoPdf = async (item, mode, onShare = sharePdf) => {
  const res = await calculatorActions.cargoByQuery(item._id);
  const query = res.data;
  const portOperations = (query.cargoList || []).filter((port) => port.operation !== "Commence");
  const saved = await actions.addDownloadPdf(buildCargoPdfDetails(query, portOperations));
  if (!saved?.data?._id) throw new Error("Could not save the cargo PDF");
  const blob = await makePdfBlob(
    <CargoPdf portOperations={portOperations} query={query} pdfSaveId={saved.data._id} />,
    "landscape"
  );
  const filename = `${query.name || "Cargo"}.pdf`;
  if (mode === "share") await onShare(blob, filename);
  else downloadPdf(blob, filename);
};
